<div class="flex flex-auto flex-column">
  <router-outlet></router-outlet>
</div>

<footer scFooter></footer>

<sc-global-notification></sc-global-notification>